'use client';

import type { FeedbackQuestion } from '@up2stay/up2promo-api-client';

import {
  FeedbackGuestFormPreview,
  type FeedbackGuestFormPreviewLabels,
} from '@/core/components/feedback/feedback-guest-form-preview';
import { PhonePreviewFrame } from '@/core/components/layout';

type FeedbackPhonePreviewProps = {
  title: string;
  contextLabel?: string | null;
  workspaceName?: string | null;
  locationName?: string | null;
  accentColor?: string | null;
  logoUrl?: string | null;
  questions: FeedbackQuestion[];
  labels: FeedbackGuestFormPreviewLabels;
  showUp2promoBranding?: boolean;
  showComment?: boolean;
  className?: string;
};

/** Phone-framed guest form preview for form editors and compose. */
export function FeedbackPhonePreview({
  title,
  contextLabel,
  workspaceName,
  locationName,
  accentColor,
  logoUrl,
  questions,
  labels,
  showUp2promoBranding = true,
  showComment = true,
  className,
}: FeedbackPhonePreviewProps) {
  return (
    <PhonePreviewFrame className={className} maxHeightClassName="max-h-[85vh]">
      <div className="h-full w-full overflow-hidden bg-background text-foreground">
        <FeedbackGuestFormPreview
          title={title || '…'}
          contextLabel={contextLabel}
          workspaceName={workspaceName}
          locationName={locationName}
          accentColor={accentColor}
          logoUrl={logoUrl}
          questions={questions}
          labels={labels}
          showUp2promoBranding={showUp2promoBranding}
          showComment={showComment}
          className="h-full"
        />
      </div>
    </PhonePreviewFrame>
  );
}
